import {
  DefaultOptionItem,
  IdTypeModel,
} from '@app/pages/clinic/models/common.model';

export const SEX_TYPE_LIST: DefaultOptionItem[] = [
  {
    id: 1,
    name: "chipRegistration.animal.male",
  },
  {
    id: 2,
    name: "chipRegistration.animal.female",
  }
];

export const ID_TYPE_LIST: IdTypeModel[] = [
  {
    id: 1,
    name: 'dropdown.passport'
  },
  {
    id: 2,
    name: 'dropdown.idCard',
  }
];

export const CHIP_LOCATION_LIST: DefaultOptionItem[] = [
  {
    id: 1,
    name: 'chipRegistration.animal.leftNeck'
  },
  {
    id: 2,
    name: 'chipRegistration.animal.crossNeck',
  }
];

export const COAT_TYPE_LIST: DefaultOptionItem[] = [
  {
    id: 1,
    name: 'chipRegistration.animal.longtHair'
  },
  {
    id: 2,
    name: 'chipRegistration.animal.mediumHair',
  },
  {
    id: 3,
    name: 'chipRegistration.animal.shortHair',
  },
  {
    id: 4,
    name: 'chipRegistration.animal.noHair',
  },
];

export const SIZE_LIST: DefaultOptionItem[] = [
  {
    id: 1,
    name: 'chipRegistration.animal.miniature',
  },
  {
    id: 2,
    name: 'chipRegistration.animal.small',
  },
  {
    id: 3,
    name: 'chipRegistration.animal.medium',
  },
  {
    id: 4,
    name: 'chipRegistration.animal.large',
  },
];
